"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BaseConfig_1 = require("../BaseConfig");
const Environment_1 = require("../../models/Environment");
const delosConfig = {
    env: Environment_1.BuildEnvironment.Delos,
    ariaCollectorUri: "https://teams.events.data.microsoft.com/Collector/3.0/",
    OneDsCollectorUri: "https://teams.events.data.microsoft.com/OneCollector/1.0/",
    publicPath: "https://teams.sovcloud-static.de",
    // telemetry: {
    // 	tenantToken: "TODO: replace-me", // TODO: delos
    // },
    urls: Object.assign(Object.assign({}, BaseConfig_1.default.urls), { absoluteUrls: Object.assign(Object.assign({}, BaseConfig_1.default.urls.absoluteUrls), { brandingService: "https://middletier.teams.sovcloud.de/beta/meetings/branding", brandingWithMeetingidService: "https://middletier.teams.sovcloud.de/beta/meetings/brandinginfo" }) }),
    ecs: Object.assign(Object.assign({}, BaseConfig_1.default.ecs), { host: "https://c2s.config.ecs.svc.sovcloud.de" }),
};
exports.default = delosConfig;
